import Swiper from 'swiper/bundle';

export default () => {
  function init() {
    const target = document.querySelector('#ymal-collection');

    new Swiper(target, {
      loop: true,
      freeMode: false,
      navigation: {
        nextEl: '.swiper-button-next--ymal',
        prevEl: '.swiper-button-prev--ymal',
      },
      // pagination: {
      //   el: '.swiper-pagination--ymal',
      //   type: 'bullets',
      //   clickable: 'true',
      // },
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        440: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        790: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });

    // Hide/Show Collection filter at the end of the pagination loop
    const filter = document.querySelectorAll(
      '#shopify-section-collection-filter',
    );

    if (target !== null) {
      filter.forEach((el) => {
        el.classList.remove('inactive-filter');
        el.classList.add('active-filter');
      }, false);
    } else {
      filter.forEach((el) => {
        el.classList.add('inactive-filter');
        el.classList.remove('active-filter');
      }, false);
    }

    console.log('YMAL Collection- Slider 👍');
  }

  return Object.freeze({
    init,
  });
};
